import { FC } from "react"
import { LOsTableWithImporter } from "../../loan-officers"
import { useIsAdmin } from "../../../hooks"

interface Props {
  orgId: string
}

const OrgDetailsLoanOfficers: FC<Props> = ({ orgId }) => {
  const isAdmin = useIsAdmin()
  return (
    <div className="p-6 bg-white">
      <LOsTableWithImporter
        searchParams={{ org_id: orgId }}
        hasNewButton
        hasViewTypeToggle={false}
        hasMasqueradeIcon={isAdmin}
      />
    </div>
  )
}

export default OrgDetailsLoanOfficers
